import React from "react";
import { updateOffsetWithDateCalendarForMonth } from "react-weekly-planning";
import dayjs from "dayjs";
import "antd/dist/reset.css";
import { CalendarTaskContextProvider } from "react-weekly-planning";

import CalendarHeader from "./components/calendarHeader";
import CalendarGrid from "./components/calendarGrid";
import { ProjectProvider } from "./contexts/ProjectContext";



export default function App() {
  const [monthOffset, setMonthOffset] = React.useState(0);
  const handlePrevMonth = () => setMonthOffset((prev) => prev - 1);
  const handleNextMonth = () => setMonthOffset((prev) => prev + 1);
  const handleToday = () => setMonthOffset(updateOffsetWithDateCalendarForMonth(new Date()));
  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) setMonthOffset(updateOffsetWithDateCalendarForMonth(date.toDate()));
  };

  return (
    <ProjectProvider>
      <CalendarTaskContextProvider hashScope="day">
        <div className="min-h-screen flex flex-col font-sans selection:bg-[#3d5a35]/20 selection:text-[#3d5a35] relative bg-transparent">
          <main className="flex-1 px-6 py-6 w-full flex flex-col max-w-full relative">
            <div className="sticky top-0 z-50 bg-transparent py-4 -mx-6 px-10 mb-8 flex items-center overflow-visible transition-all">
              <div className="flex-1">
                <CalendarHeader monthOffset={monthOffset} onPrev={handlePrevMonth} onNext={handleNextMonth} onToday={handleToday} onDateChange={handleDateChange} />
              </div>
            </div>

            {/* Nature Decoration - Floating Pot */}
            <div className="absolute top-[50px] right-0 z-[100]">
              <img
                src="pot.png"
                alt="Decoration"
                className="w-[150px] drop-shadow-xl"
              />
            </div>

            <div className="flex-1">
              <CalendarGrid monthOffset={monthOffset} />
            </div>
          </main>
        </div>
      </CalendarTaskContextProvider>
    </ProjectProvider>
  );

}